export default __webpack_public_path__ + "static/media/logo-cassandra.c13e38e8.svg";